import React, { useContext, useState, useMemo, useEffect } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import { useNavigate, Link } from 'react-router-dom';
import LoginController from '../../controllers/member/LoginController';
import ban1Image from '../../assets/img/contents/ban1.png';
import ban2Image from '../../assets/img/contents/ban2.png';
import ban3Image from '../../assets/img/contents/ban3.png';
import { nlPost } from '../../apis/notLoginApi';

const NoticeList = () => {
  const [notices, setNotices] = useState([]);
  const navigate = useNavigate();

  const fetchNotices = async () => {
    try {
      const url = '/cs/ask/search.do';
      const filters = { ctgryId: 'NOTICE' };
      const response = await nlPost(url, filters);
      const sortedNotices = Array.isArray(response)
        ? response.sort((a, b) => new Date(b.regDt) - new Date(a.regDt))
        : [];
      setNotices(sortedNotices.slice(0, 3));
    } catch (error) {
      setNotices([]);
    }
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  const handleNoticeClick = notice => {
    navigate('/cs/noticeList', { state: { selectedNotice: notice } });
  };

  return (
    <ul className="news-tbl-list">
      {notices.map(notice => (
        <li key={notice.qstnId}>
          <button
            className="tit"
            onClick={e => {
              e.preventDefault();
              handleNoticeClick(notice);
            }}
          >
            {notice.qstnTtl}
          </button>
          <span className="date">{notice.regDt.split(' ')[0]}</span>
        </li>
      ))}
    </ul>
  );
};

const Dashboard = () => {
  const { store, updateStore, resetTimer } = useGlobalStore();

  // 만족도 조사 팝업
  useEffect(() => {
    document.title = '산업재해부담작업예방플랫폼';

    // 로그인한 사용자에게만 팝업 표시
    if (!store?.logined) {
      return;
    }

    const surveyWindow = window.open(
      '',
      '_blank',
      'scrollbars=yes,resizable=yes'
    );

    if (surveyWindow) {
      surveyWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>만족도 조사</title>
          <meta charset="utf-8">
          <style>
            body {
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
              margin: 0;
              padding: 0;
              background-color: #f8f9fa;
              display: inline-block;
            }
            .image-section {
              width: 100%;
              text-align: center;
            }
            .image-section img {
              display: block;
              width: 100%;
              height: auto;
            }
            .content-section {
              padding: 10px 10px;
              text-align: center;
            }
            h2 {
              color: #2c3e50;
              margin-bottom: 20px;
              margin-top: 0;
            }
            p {
              color: #555;
              line-height: 1.6;
              margin-bottom: 25px;
            }
            .btn {
              display: inline-block;
              padding: 12px 80px;
              margin: 5;
              border: none;
              border-radius: 8px;
              cursor: pointer;
              text-decoration: none;
              font-size: 18px;
              font-weight: 600;
              transition: all 0.3s;
            }
            .btn-primary {
              background-color: #007bff;
              color: white;
            }
            .btn-primary:hover {
              background-color: #0056b3;
            }
          </style>
          <script>
            window.addEventListener('load', function() {
              var img = document.querySelector('.image-section img');
              if (img && img.complete) {
                var width = (img.naturalWidth * 0.5) + 16;
                var height = (img.naturalHeight * 0.5) + document.querySelector('.content-section').offsetHeight + 80;
                window.resizeTo(width, height);
              } else if (img) {
                img.addEventListener('load', function() {
                  var width = (img.naturalWidth * 0.5) + 16;
                  var height = (img.naturalHeight * 0.5) + document.querySelector('.content-section').offsetHeight + 50;
                  window.resizeTo(width, height);
                });
              }
            });
          </script>
        </head>
        <body>
          <div class="image-section">
            <img src="${window.location.origin}/popup_02.png" alt="만족도 조사">
          </div>
          <div class="content-section">
            <a href="https://naver.me/G5P0aPqt" target="_blank" class="btn btn-primary">
              만족도 조사 참여하기
            </a>
          </div>
        </body>
        </html>
      `);
      surveyWindow.document.close();
    }
  }, [store?.logined]);
  const modalService = useContext(ModalContext);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('business');
  const [valueObj, setValueObj] = useState({
    id: '',
    password: '',
    userType: 'E',
  });
  const [loginMsgDp, setLoginMsgDp] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);

  const loginController = useMemo(() => {
    return new LoginController(
      { store, updateStore, resetTimer },
      modalService,
      {},
      () => {},
      { valueObj, setValueObj },
      { loginMsgDp, setLoginMsgDp }
    );
  }, [
    store,
    updateStore,
    resetTimer,
    modalService,
    navigate,
    valueObj,
    loginMsgDp,
  ]);

  const handleLogin = () => {
    const loginPayload = {
      userType: valueObj.userType,
      id: valueObj.id,
      password: valueObj.password,
    };

    loginController.fnLogin(loginPayload);
  };

  const handleValueChange = (model, value) => {
    setValueObj({ ...valueObj, [model]: value });
  };

  const handleTabClick = (tab, e) => {
    e.preventDefault();
    setActiveTab(tab);
    setValueObj({ ...valueObj, userType: tab === 'individual' ? 'U' : 'E' });
  };

  const togglePasswordVisibility = isVisible => {
    setPasswordVisible(isVisible);
  };

  return (
    <>
      <div className="main-vban-wrap bg">
        <div className="vb-swiper">
          <div className="swiper">
            <ul className="swiper-wrapper">
              <li className="swiper-slide slide01">
                <div className="in inner">
                  <div className="text">
                    <p className="tit">
                      근골격계질환 예방,
                      <br />
                      유해요인 제거로 안전한 작업환경
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="container">
        {!store?.logined && (
          <div className="main-sect bg">
            <div className="inner">
              <div className="d-card d-card-login">
                <div className="text">
                  <p className="title">회원 로그인</p>
                  <p className="desc">
                    로그인을 통해 산업재해 부담작업 예방 플랫폼의 회원 전용
                    서비스를 이용하실 수 있습니다.
                  </p>
                </div>
                <div className="in">
                  <div className="login-wrap">
                    <fieldset>
                      <legend>로그인 폼</legend>
                      <div className="fieldset">
                        <div className="form-group chk-area">
                          {/* 기업사용자 로그인만 사용 */}
                          {/* <div className="tab-login-type">
                            <a
                              href=""
                              className={
                                activeTab === 'individual' ? 'active' : ''
                              }
                              onClick={e => handleTabClick('individual', e)}
                              style={{ cursor: 'pointer' }}
                            >
                              개인회원
                            </a>
                            <a
                              href=""
                              className={
                                activeTab === 'business' ? 'active' : ''
                              }
                              onClick={e => handleTabClick('business', e)}
                              style={{ cursor: 'pointer' }}
                            >
                              기업회원
                            </a>
                          </div> */}
                        </div>
                        <div className="main-login-form">
                          <div className="form-group">
                            <div className="form-conts">
                              <label className="hidden-label" htmlFor="id">
                                라벨
                              </label>
                              <input
                                type="text"
                                name="id"
                                id="id"
                                placeholder="아이디"
                                className="form-control md"
                                autoComplete="off"
                                onChange={e =>
                                  handleValueChange('id', e.target.value)
                                }
                                aria-labelledby="id"
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="form-conts btn-ico-wrap">
                              <label
                                className="hidden-label"
                                htmlFor="password"
                              >
                                라벨
                              </label>
                              <input
                                type={passwordVisible ? 'text' : 'password'}
                                name="password"
                                id="password"
                                placeholder="비밀번호"
                                autoComplete="off"
                                className="form-control md"
                                onChange={e =>
                                  handleValueChange('password', e.target.value)
                                }
                                aria-labelledby="password"
                              />
                              <button
                                type="button"
                                className="btn btn-ico ico-pw-visible md"
                                onMouseDown={() =>
                                  togglePasswordVisibility(true)
                                }
                                onMouseUp={() =>
                                  togglePasswordVisibility(false)
                                }
                                onMouseLeave={() =>
                                  togglePasswordVisibility(false)
                                }
                              >
                                <span className="sr-only">
                                  입력한 비밀번호 보기
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        {loginMsgDp.length > 0 && (
                          <p
                            className="text-point"
                            dangerouslySetInnerHTML={{
                              __html: loginMsgDp,
                            }}
                          ></p>
                        )}
                        <div className="form-group">
                          <button
                            type="submit"
                            className="btn primary"
                            onClick={handleLogin}
                          >
                            로그인
                          </button>
                        </div>
                        <div className="form-group">
                          <ul className="link-group">
                            <li>
                              <Link
                                to="/member/findId"
                                className="btn md btn-txt"
                              >
                                아이디 찾기
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/member/findPassword"
                                className="btn md btn-txt"
                              >
                                비밀번호 찾기
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/member/joinPage"
                                className="btn md btn-txt"
                              >
                                회원가입
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="main-sect">
          <div className="inner">
            <div className="main-box-responsive">
              <div className="d-auto inner">
                <div className="main-tit-wrap">
                  <h2 className="tit">서비스 선택</h2>
                </div>
                <div className="main-d-ban">
                  <a href="/ai/guide" className="service-ban ban01">
                    <div className="text">
                      <p className="title">AI 분석</p>
                      <span>
                        AI 기술을 활용하여
                        <br />
                        체계적인 분석이 가능합니다.
                      </span>
                    </div>
                  </a>
                  <a
                    className="service-ban ban02"
                    onClick={e => {
                      e.preventDefault();
                      if (store?.logined) {
                        window.location.href = '/expert/analyze/list';
                      } else {
                        alert('로그인 후 이용하실 수 있습니다.');
                        window.location.href = '/member/login';
                      }
                    }}
                  >
                    <div className="text">
                      <p className="title">전문가 분석</p>
                      <span>
                        각 분야 전문가가
                        <br />
                        심도있게 분석합니다.
                      </span>
                    </div>
                  </a>
                </div>
              </div>
              <div className="d-auto inner">
                <div className="main-tit-wrap">
                  <h2 className="tit">공지사항</h2>
                  <a href="/cs/noticeList" className="btn md btn-txt ico-plus">
                    더보기
                  </a>
                </div>
                <div className="in outline">
                  <NoticeList />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="main-sect">
          <div className="inner">
            <div className="main-tit-wrap">
              <h2 className="tit">자주찾는 서비스</h2>
            </div>
            <ul className="menu-list-rel outline">
              <li>
                <a href="/member/joinPage">
                  <div className="d-card line">
                    <div className="in">
                      <div className="text">
                        <p className="c-tit">회원가입</p>
                        <p className="c-txt">
                          가입 후 회원서비스 이용이 가능합니다.
                        </p>
                      </div>
                      <p className="c-btn">
                        <span className="btn sm btn-txt ico-more" />
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a href="/cs/faqList">
                  <div className="d-card line">
                    <div className="in">
                      <div className="text">
                        <p className="c-tit">고객센터</p>
                        <p className="c-txt">친절하게 답해 드리겠습니다.</p>
                      </div>
                      <p className="c-btn">
                        <span className="btn sm btn-txt ico-more" />
                      </p>
                    </div>
                  </div>
                </a>
              </li>

              {/* 
              <li>
                <a href="/pay/selectSub">
                  <div className="d-card line">
                    <div className="in">
                      <div className="text">
                        <p className="c-tit">구독 상품 조회</p>
                        <p className="c-txt">
                          구독 후 분석 신청 서비스가 가능합니다.
                        </p>
                      </div>
                      <p className="c-btn">
                        <span className="btn sm btn-txt ico-more" />
                      </p>
                    </div>
                  </div>
                </a>
              </li>
               */}
            </ul>
          </div>
        </div>

        <div className="main-sect tb">
          <div className="related-site">
            <a
              href="https://www.busan.go.kr/index"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ban2Image} alt="부산광역시" />
            </a>
            <span className="vr" />
            <a
              href="https://globit.co.kr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={ban3Image}
                alt="글로비트컨소시엄"
                style={{ width: '200px', heigh: '30px' }}
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
